import { render } from "./AllMetadatasList.vue?vue&type=template&id=6798adaa&scoped=true"
import script from "./AllMetadatasList.vue?vue&type=script&lang=js"
export * from "./AllMetadatasList.vue?vue&type=script&lang=js"

import "./AllMetadatasList.vue?vue&type=style&index=0&id=6798adaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6798adaa"]])

export default __exports__